// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__L5RBO","containerItemsCenter":"Skeleton_containerItemsCenter__3ZEmZ"};